import { ApiPrefix } from '@/constants/constants';
import request from '@/utils/request';
import { BsqyReqParamsType } from './type';
import util from '@/utils/util';

export const LoginConfigApi = {
	// 查询列表
	queryList: (params?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/loginUserConfig/list',
			method: 'get',
			params,
		});
	},
	AddList: (data?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/loginUserConfig',
			method: 'post',
			data,
		});
	},
	EditList: (data?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/loginUserConfig',
			method: 'put',
			data,
		});
	},
	DeleteList: (id?: string) => {
		return request({
			url: ApiPrefix.GroupDefault + '/loginUserConfig/' + id,
			method: 'delete',
		});
	},
	//根据id查询列表
	QueryIdList: (id?: string | any) => {
		return request({
			url: ApiPrefix.GroupDefault + '/loginUserConfig/' + id,
			method: 'get',
		});
	},
	//在线状态查询列表
	zxqkList: (params?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/dldjzt/list',
			method: 'get',
			params,
		});
	},
	//涉税机构代理
	ssfwjgList: (params?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/dljg',
			method: 'get',
			params,
		});
	},
	ssfwjgAddList: (data?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/dljg',
			method: 'post',
			data,
		});
	},
	ssfwjgDeleteList: (id?: string) => {
		return request({
			url: ApiPrefix.GroupDefault + '/dljg/' + id,
			method: 'delete',
		});
	},
	ssfwjgIdList: (id?: string) => {
		return request({
			url: ApiPrefix.GroupDefault + '/dljg/' + id,
			method: 'get',
		});
	},
	ssfwjgEditList: (data?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/dljg',
			method: 'put',
			data,
		});
	},
	// 自然人密码验证-同步
	verifyPassword: (data?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/loginUserConfig/mmyzTpassSync',
			method: 'POST',
			data,
		});
	},
	// 自然人密码验证-异步
	asyncVerifyPassword: (data?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/loginUserConfig/mmyzTpassAsync',
			method: 'POST',
			data,
			headers: { 'Content-Type': 'multipart/form-data' },
		});
	},
};

export const QyLoginConfigApi = {
	// 查询列表
	queryList: (params?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/qydlpz/list',
			method: 'get',
			params,
		});
	},
	queryIdList: (id?: string) => {
		return request({
			url: ApiPrefix.GroupDefault + '/qydlpz/detail/' + id,
			method: 'get',
		});
	},
	//新增列表
	AddList: (data?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/qydlpz/associateUser',
			method: 'post',
			data,
		});
	},
	//根据代理机构id查询机构关联的登录用户
	dljgIdList: (id?: string) => {
		return request({
			url: ApiPrefix.GroupDefault + '/loginUserConfig/getByDljgId/' + id,
			method: 'get',
		});
	},
	//报税区域字典
	bsqyList: (params?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/bsqy/dict',
			method: 'get',
			params,
		});
	},
	jcConnentList: (data?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/qydlpz/cancleAssociateUser/' + data,
			method: 'put',
		});
	},
};

export const commonQyApi = {
	/** 新建企业 */
	queryBsqyList: (params?: BsqyReqParamsType) => {
		return request({
			url: ApiPrefix.GroupDefault + '/bsqy',
			method: 'GET',
			params,
		});
	},
	// 获取用户管理的企业信息
	queryUserQyList() {
		return request({
			url: ApiPrefix.GroupDefault + '/qygl/qiye/list',
			method: 'GET',
		});
	},
	changeQyId(id: string) {
		return request({
			url: ApiPrefix.GroupDefault + '/xiaoxiang/index/qiye/switch?id=' + id,
			method: 'POST',
		});
	},
};

export const saasApi = {
	/** 新建企业 */
	addList: (data?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/qyyw',
			method: 'post',
			data,
		});
	},
	fzrTree: (isFilterDisabled: boolean = true) => {
		return new Promise<any>((resolve, reject) => {
			request({
				url: ApiPrefix.SysDefault + '/org/queryOrgAndAccountTreeList',
				method: 'GET',
				// isPower: '0' 显示所有机构下的用户，与SaaS不同
				params: { isPower: '0' },
			})
				.then((res: any) => {
					const data = res.data;
					const treeData = util.formatDataToTree(data);
					const fliterTreeData = removeEmptyAccountListNodes(treeData, isFilterDisabled);
					resolve({ data: fliterTreeData });
				})
				.catch((err: any) => {
					reject(err);
				});
		});
	},
	/** 关注 */
	followList: (id?: Array<string>) => {
		return request({
			url: ApiPrefix.GroupDefault + `/gzqy/gz/` + id,
			method: 'get',
		});
	},
	/** 取消关注 */
	unfollowList: (id?: Array<string>) => {
		return request({
			url: ApiPrefix.GroupDefault + `/gzqy/qxgz/` + id,
			method: 'get',
		});
	},
	//分享登录二维码获取
	oneLoginfxErweima: (params?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/quickLogin/getLoginShareQrcode',
			method: 'get',
			params,
		});
	},
	//一键登录下载分享二维码
	oneLoginDownloadErweima: (params?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/quickLogin/downloadLoginShareQrcode',
			method: 'get',
			params: params,
			responseType: 'blob',
		});
	},
	//获取登录账号信息接口
	getUserLoginList: (params?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/quickLogin/getElecAccount',
			method: 'get',
			params,
		});
	},
	//查询一键登录电局登录是否在线接口
	oneLoginStatusList: (params?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/quickLogin/queryLoginStatus',
			method: 'get',
			params: params,
			timeout: 60 * 1000,
		});
	},
	//一键登录电局登录方式接口
	oneLoginList: (data?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/quickLogin/elecLogin',
			method: 'post',
			data: data,
			timeout: 60 * 1000,
		});
	},
	//更新电局登录信息
	oneLoginUpdateUserInfo: (data?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/quickLogin/updateLoginConfig',
			method: 'post',
			data,
		});
	},
	//一键登录二维码电局登录状态接口
	oneLoginerweimaList: (id?: string) => {
		return request({
			url: ApiPrefix.GroupDefault + '/quickLogin/qrcodeLoginStatus/' + id,
			method: 'get',
		});
	},
};

const removeEmptyAccountListNodes = (data: any, isFilterDisabled: boolean) => {
	return data.filter((node: any) => {
		if (node.children) {
			node.children = removeEmptyAccountListNodes(node.children, isFilterDisabled);
		}
		if ((!node.children || node.children.length === 0) && (!node.accountList || node.accountList.length === 0)) {
			return false;
		}
		if (isFilterDisabled && node.disabled) {
			return false;
		}
		if (isFilterDisabled && node.accountList && node.accountList.length > 0) {
			node.accountList = node.accountList.filter((account: any) => {
				if (account.disabled) {
					return false;
				}
				return true;
			});
		}
		return true;
	});
};

export const qyxxglApi = {
	// 查询获取当前租户开通服务列表
	getKtfwlb: () => {
		return request({
			url: ApiPrefix.GroupDefault + `/qyyw/ktfwlb`,
			method: 'GET',
		});
	},
	// 查询开通服务列表
	updateKtfw: (qyid: string, data: any[]) => {
		return request({
			url: ApiPrefix.GroupDefault + `/ktfw/${qyid}`,
			method: 'PUT',
			data,
		});
	},
};

export { default as djzhsqApi } from './djzhsq';

export { default as lqtdpzApi } from './lqtdpz';
